import { quickNews } from '@/mocks/guagua';

export default function QuickTimeline() {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-heading text-xl font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-timer-flash-line text-secondary-500" aria-hidden="true"></i>
          快讯时间线
        </h3>
        <span className="flex items-center gap-1 text-xs text-secondary-600 font-medium">
          <span className="w-1.5 h-1.5 rounded-full bg-secondary-500 animate-pulse-soft"></span>
          滚动更新
        </span>
      </div>
      <ol className="relative border-l border-background-200 ml-1.5 space-y-5">
        {quickNews.slice(0, 6).map((item, index) => (
          <li key={`${item.time}-${index}`} className="relative pl-6">
            <span
              className={`absolute -left-[5px] top-1.5 w-2.5 h-2.5 rounded-full border-2 border-background-50 ${
                index === 0 ? 'bg-primary-500' : 'bg-secondary-400'
              }`}
            ></span>
            <div className="flex items-center gap-2 mb-1">
              <span className="font-heading text-sm font-bold text-foreground-950">{item.time}</span>
              <span className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-800">
                {item.tag}
              </span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}